import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext'; // Language context

const NavLinks = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const { language } = useLanguage();

  const handleMouseEnter = (menu) => {
    setOpenDropdown(menu);
  };

  const handleMouseLeave = () => {
    setOpenDropdown(null);
  };

  return (
    <div className="flex flex-col lg:flex-row items-center justify-center space-y-4 lg:space-y-0 lg:space-x-6">
      {/* Artistic Program */}
      <div
        className="relative"
        onMouseEnter={() => handleMouseEnter('artistic')}
        onMouseLeave={handleMouseLeave}
      >
        <NavLink
          className={({ isActive }) =>
            `px-2 font-semibold hover:text-green-500 ${isActive ? 'text-green-500' : 'text-gray-700'}`
          }
          to="/artistic-program"
          role="button"
          aria-haspopup="true"
          aria-expanded={openDropdown === 'artistic'}
          aria-controls="artistic-dropdown"
          aria-label={language === 'Shqip' ? 'Hap nën-menynë e programeve artistike' : 'Open the Artistic Program dropdown menu'}
        >
          {language === 'Shqip' ? 'Programi Artistik' : 'Artistic Program'}
        </NavLink>
        <div
          id="artistic-dropdown"
          role="menu"
          tabIndex={-1}
          aria-hidden={openDropdown !== 'artistic'}
          className={`navbar-dropdown ${openDropdown === 'artistic' ? 'open' : ''}`}
        >
          <NavLink
            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            to="/artistic-program/audio-descriptions"
            role="menuitem"
            tabIndex={0}
            aria-label={
              language === 'Shqip' ? 'Përshkrimet Zanore në programet artistike' : 'Audio Descriptions in Artistic Programs'
            }
          >
            {language === 'Shqip' ? 'Përshkrimet Zanore' : 'Audio Descriptions'}
          </NavLink>
          <NavLink
            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            to="/artistic-program/exhibitions"
            role="menuitem"
            tabIndex={0}
            aria-label={language === 'Shqip' ? 'Ekspozitat në programet artistike' : 'Exhibitions in Artistic Programs'}
          >
            {language === 'Shqip' ? 'Ekspozitat' : 'Exhibitions'}
          </NavLink>
        </div>
      </div>

      {/* Educational Program */}
      <div
        className="relative"
        onMouseEnter={() => handleMouseEnter('educational')}
        onMouseLeave={handleMouseLeave}
      >
        <NavLink
          className={({ isActive }) =>
            `px-2 font-semibold hover:text-green-500 ${isActive ? 'text-green-500' : 'text-gray-700'}`
          }
          to="/educational-program"
          role="button"
          aria-haspopup="true"
          aria-expanded={openDropdown === 'educational'}
          aria-controls="educational-dropdown"
          aria-label={language === 'Shqip' ? 'Hap nën-menynë e programeve edukative' : 'Open the Educational Program dropdown menu'}
        >
          {language === 'Shqip' ? 'Programi Edukativ' : 'Educational Program'}
        </NavLink>
        <div
          id="educational-dropdown"
          role="menu"
          tabIndex={-1}
          aria-hidden={openDropdown !== 'educational'}
          className={`navbar-dropdown ${openDropdown === 'educational' ? 'open' : ''}`}
        >
          <NavLink
            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            to="/educational-program/laboratories"
            role="menuitem"
            tabIndex={0}
            aria-label={
              language === 'Shqip' ? 'Laboratorët në programet edukative' : 'Laboratories in Educational Programs'
            }
          >
            {language === 'Shqip' ? 'Laboratorët' : 'Laboratories'}
          </NavLink>
          <NavLink
            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            to="/educational-program/talks-reading"
            role="menuitem"
            tabIndex={0}
            aria-label={
              language === 'Shqip' ? 'Bisedat dhe Seancat Leximore në programet edukative' : 'Talks and Reading Sessions'
            }
          >
            {language === 'Shqip' ? 'Bisedat dhe Seancat Leximore' : 'Talks and Reading'}
          </NavLink>
        </div>
      </div>

      {/* Resources */}
      <NavLink
        className={({ isActive }) =>
          `px-2 font-semibold hover:text-green-500 ${isActive ? 'text-green-500' : 'text-gray-700'}`
        }
        to="/resources"
        aria-label={language === 'Shqip' ? 'Faqja e burimeve' : 'Resources Page'}
      >
        {language === 'Shqip' ? 'Burimet' : 'Resources'}
      </NavLink>
    </div>
  );
};

export default NavLinks;